import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d61faf7c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d61faf7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61faf7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d61faf7c')) {
      api.createRecord('d61faf7c', component.options)
    } else {
      api.reload('d61faf7c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d61faf7c&scoped=true&", function () {
      api.rerender('d61faf7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MaUjJODNQiOc/JS/comp/GuestBox.vue"
export default component.exports